import React from "react";

import RecipeCard from "./RecipeCard";

import { RecipeContainer } from "./style";

function RecipeListContainer(props: any) {
  const { data } = props;

  return (
    <RecipeContainer>
      {data?.map((recipe) => {
        return <RecipeCard key={recipe.id} data={recipe} />;
      })}
    </RecipeContainer>
  );
}

export default RecipeListContainer;
